import { Select } from '@bambi/component-library/src/components/inputs/Select/Select';

import { useRejectionReasonOptions } from './useRejectionReasonOptions';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

type RejectionReasonSelectProps = {
  tripId: string;
  onChange: (value: SelectOption | undefined) => void;
};

export function RejectionReasonSelect({
  tripId,
  onChange = () => {},
}: RejectionReasonSelectProps) {
  const options = useRejectionReasonOptions(tripId);
  return (
    <Select
      options={options}
      disabled={options.length === 0}
      placeholder={
        options.length === 0 ? 'Loading options...' : 'Select a reason'
      }
      onChange={onChange}
    />
  );
}
